// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.note-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 176px;
  max-width: 236px;
  font-family: Inter, "Public Sans", Roboto, Helvetica, Arial, sans-serif;
}

.note-card {
  position: relative;
  padding: 8px 10px;
  background: #fff8f1;
  border: 1px solid #fde8c8;
  border-radius: 10px;
}

.note-card:not(.note-card--customer) {
  padding-right: 28px;
}

.note-card--customer {
  background: #f4f7ff;
  border-color: #d6e4ff;
}

.note-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 6px;
}

.note-card__label {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 999px;
  background: #ffedd5;
  color: #c2410c;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.note-card--customer .note-card__label {
  background: #dbeafe;
  color: #1d4ed8;
}

.note-card__body {
  color: #334155;
  font-size: 12px;
  line-height: 1.45;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.note-line + .note-line {
  margin-top: 6px;
}

.note-line__meta {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 2px;
}

.note-line__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fdba74;
  color: #7c2d12;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
}

.note-line__author {
  color: #9a3412;
  font-size: 10px;
  font-weight: 600;
}

.note-line__text {
  color: #1e293b;
}

.note-line--more {
  color: #94a3b8;
  letter-spacing: 0.08em;
}

.note-card__edit {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.note-card__edit:hover {
  background: #fff;
  color: #c2410c;
}

.note-add {
  align-self: flex-start;
  padding: 4px 10px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}

.note-add:hover {
  border-color: #4d7cfe;
  background: #f8fafc;
  color: #4d7cfe;
}
`, "",{"version":3,"sources":["webpack://./src/examples/NoteCell/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".note-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 176px;\n  max-width: 236px;\n  font-family: Inter, \"Public Sans\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n.note-card {\n  position: relative;\n  padding: 8px 10px;\n  background: #fff8f1;\n  border: 1px solid #fde8c8;\n  border-radius: 10px;\n}\n\n.note-card:not(.note-card--customer) {\n  padding-right: 28px;\n}\n\n.note-card--customer {\n  background: #f4f7ff;\n  border-color: #d6e4ff;\n}\n\n.note-card__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n\n.note-card__label {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: #ffedd5;\n  color: #c2410c;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.note-card--customer .note-card__label {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.note-card__body {\n  color: #334155;\n  font-size: 12px;\n  line-height: 1.45;\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n.note-line + .note-line {\n  margin-top: 6px;\n}\n\n.note-line__meta {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 2px;\n}\n\n.note-line__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fdba74;\n  color: #7c2d12;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.note-line__author {\n  color: #9a3412;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.note-line__text {\n  color: #1e293b;\n}\n\n.note-line--more {\n  color: #94a3b8;\n  letter-spacing: 0.08em;\n}\n\n.note-card__edit {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.note-card__edit:hover {\n  background: #fff;\n  color: #c2410c;\n}\n\n.note-add {\n  align-self: flex-start;\n  padding: 4px 10px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.note-add:hover {\n  border-color: #4d7cfe;\n  background: #f8fafc;\n  color: #4d7cfe;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
